import { AvailabilityHoursFormConfig, getAvailabilityHoursFormFields } from '@frontend/schedule-availability-hours';
import { isValidUrl } from '@frontend/uri';
import { FormConfig } from '@frontend/design-system';
import { URL_ERROR_VALIDATION } from '../../../constants';
import { emailField, phoneField, switchField, textField } from '../../../utils/field-config-helpers';

const baseFields = {
  address: textField({
    required: true,
  }),
  website: textField({
    validator: (props) => {
      const { value } = props;
      if (isValidUrl(value)) return '';
      else return URL_ERROR_VALIDATION;
    },
  }),
  linkToFaqs: textField({
    validator: (props) => {
      const { value } = props;
      if (isValidUrl(value)) return '';
      else return URL_ERROR_VALIDATION;
    },
  }),
  locationTips: textField(),
  parkingTips: textField(),
  billingName: textField({
    required: true,
  }),
  billingEmail: emailField({
    required: true,
  }),
  billingPhoneNumber: phoneField({
    required: true,
  }),
  newPatients: switchField(),
  childrenAsPatients: textField(),
  specificProcedures: textField(),
  differentiation: textField(),
  comforting: textField(),
} satisfies FormConfig;

// Combine base fields with availability hours fields
export const businessProfileFields = {
  ...baseFields,
  ...getAvailabilityHoursFormFields(),
} satisfies FormConfig;

// Explicitly type to include both base fields and availability hours fields
export type BusinessProfileFieldTypes = typeof baseFields & AvailabilityHoursFormConfig;
